<template>

    <BasicDialog @close="closeClicked" :rounded="'rounded-24'">
        <div class="d-flex flex-column align-center ga-3">



            <img :src="AppConfigs.staticImages.PAYOUTWITHDRAWALFAILED" class="payout-withdrawl-dialog__image">

            <span class="text-h5 font-weight-bold text-center payout-withdrawl-dialog__failed-text">
                Payout Failed
            </span>

            <span class="text-body-2 mt-1 text-center">
                {{ payoutData }}
            </span>

            <v-btn rounded="pill" @click="closeClicked" class="button--primary px-16 py-6 d-flex text-none">
                <span>Go Back</span>
            </v-btn>



        </div>
    </BasicDialog>
</template>



<script setup>

import { AppConfigs } from "@/app.configs";
import { PayoutStore } from "@/store/PayoutStore";
import { computed, watch, ref, provide } from "vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

const openDialog = ref(false);
provide("openDialog", openDialog);

const payoutStore = PayoutStore();
const payoutData = computed(() => payoutStore.FailureResponseMessage);

watch(payoutData, () => {
    if(payoutData.value !== "")
    openDialog.value = true;
});

const closeClicked = () => {
    payoutStore.FailureResponseMessage = "";
    openDialog.value = false;
};

</script>